import { getAPIUrl } from '../helpers/App';

export const APIgetNotifications = params => (
  window.axios.get(getAPIUrl('/notifications'), { params })
    .then(response => (response))
);

export const APIgetNotification = notificationId => (
  window.axios.get(getAPIUrl(`/notifications/${notificationId}`))
    .then(response => (response))
);

export const APImarkNotificationRead = notificationId => (
  window.axios.patch(getAPIUrl(`/notifications/${notificationId}/read`))
    .then(response => (response))
);

export const APImarkNotificationUnread = notificationId => (
  window.axios.patch(getAPIUrl(`/notifications/${notificationId}/unread`))
    .then(response => (response))
);

export const APImarkAllNotificationsRead = () => (
  window.axios.patch(getAPIUrl('/notifications/read'))
    .then(response => (response))
);

export const APIdeleteNotification = notificationId => (
  window.axios.delete(getAPIUrl(`/notifications/${notificationId}`))
    .then(response => (response))
);
